module.exports = __webpack_public_path__ + "static/media/husaria.35b4869b.png";